import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Renderer } from '@angular/core';
import { Subject } from 'rxjs';
import { InformesService } from 'app/services/informes.service';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InformacionProcedimientosComponent } from 'app/modals/informacion-procedimientos/informacion-procedimientos.component';
import { ServiciosIassAuditoriaComponent } from '../../../modals/servicios-iass-auditoria/servicios-iass-auditoria.component';
import { formatTime, currentDate } from 'utilities/util'
@Component({
  selector: 'app-iass-auditoria',
  templateUrl: './iass-auditoria.component.html',
  styleUrls: ['./iass-auditoria.component.scss']
})
export class IassAuditoriaComponent implements OnInit {
    public dtOptions;
    public fechaInicio :string;
    public fechafin :string;
    public tableOpts;
    public dtTrigger:Subject<void>;
    public fechaInicialF:string;
    public fechaFinalFormateada:string;
    @ViewChild(DataTableDirective, {static:true})
    tabla: DataTableDirective;

    constructor(private _informes:InformesService, private _renderer:Renderer, private dialog:MatDialog) {
      this.dtTrigger = new Subject();
      this.fechaInicio = currentDate();
      this.fechafin = currentDate();
      this.dtTrigger.next();
      this.tableOpts = [];
    }

    ngOnInit() {
      this.dtOptions = { 
        columns:[
          {
            title:'Tratamiento',
            render: (data, type, row, meta)=>{
              return data;
            }
          },
          {
            title:'Requieren Seguimiento',
            render: (data, type, row, meta)=>{
              return data;
            }
          },
          {
            title:'Con observaciones',
            render: (data, type, row, meta)=>{
              return data;
            }
          }
        ]
      }
    }

    /**
     * obternetData
     */
    public buscar() {
      const arregloInicio = formatTime(this.fechaInicio);
      const arregloFin = formatTime(this.fechafin);
      this._informes.iassAudit(arregloInicio, arregloFin)
        .subscribe((data:any) => {
          this.rerender();
          this.tableOpts = data;
        });
    }

    /**
     * rerender
     */
    public rerender() {
      this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destruimos la instancia del datatable para re renderizar la tabla
        dtInstance.destroy();
        // Disparamos el evento de el subject para que la tabla vuelva a instanciarse
        this.dtTrigger.next();
      })
    }
    ngAfterViewInit(){
      this.dtTrigger.next();
      this._renderer.listenGlobal('document', 'click', (e) => {
        e.stopPropagation();
        if (!e.target.hasAttribute('tratamiento')) return;
        this.dialog.open(InformacionProcedimientosComponent, {
          height:'75%',
          width:'75%',
          data : {
            tratamiento : e.target.getAttribute('tratamiento'),
            fechaInicial: this.fechaInicialF,
            fechaFinal:this.fechaFinalFormateada
          }
        })
      });
    }

    ngOnDestroy(): void {
      //Called once, before the instance is destroyed.
      //Add 'implements OnDestroy' to the class.
      this.dtTrigger.unsubscribe();
    } 
    public abrirModalServicios(tratamiento,csegui,lista="requeridos"){
      if(csegui!=0){
        const ref:MatDialogRef<ServiciosIassAuditoriaComponent> = this.dialog.open(ServiciosIassAuditoriaComponent, {
          data:{fecha1:formatTime(this.fechaInicio),fecha2:formatTime(this.fechafin),tratamiento, lista},
          width:'100vw',
        })

      }
    }

    focus(){
      console.log("focus")
    }

    blur(){
      console.log("blur")
    }
}
